// extracted by mini-css-extract-plugin
module.exports = {"wave":"Spinner_wave__T_xO5","dot":"Spinner_dot__1jiTc","childText":"Spinner_childText__aH7Nu"};